import React, {lazy, Suspense} from "react";
import { Routes, Route } from "react-router-dom";
import { RecoilRoot } from 'recoil';

const FindAWriter = lazy(() => import('./pages/find-a-writer.js'));
const MemberDirectory = lazy(() => import('./pages/member-directory.js'));


function App() {
  return (
    <RecoilRoot>
      <Routes>
        <Route
          path="member-directory/*"
          element={
            <Suspense fallback={<div className="lds-ripple"><div></div><div></div></div>}>
              <MemberDirectory />
            </Suspense>
          }
        />
        <Route
          path="finder/*"
          element={
            <Suspense fallback={<div className="lds-ripple"><div></div><div></div></div>}>
              <FindAWriter />
            </Suspense>
          }
        />
      </Routes>
    </RecoilRoot>
  );
}

export default App;